import { FC, memo, useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import styled from 'styled-components';

import { AUTH_ROUTES } from '@navigation/types';
import { saveRedirectPath } from '@utils/redirect';
import AuthLayout from '@components/layouts/AuthLayout';
import AuthTitle from '@components/auth/AuthTitle';
import AuthOptions from '@components/auth/AuthOptions';
import { LogInForm } from '@components/form/LogInForm';
import { PremierText, GradientPremierText } from '@components/text';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 36px;
`;

const CreateAccountButton = styled(TouchableOpacity)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
`;

const CreateAccountText = styled(GradientPremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize['2xl']};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.purple[500]};

  &:hover {
    opacity: 0.8;
  }
`;

const LogIn: FC = () => {
  const location = useLocation();

  useEffect(() => {
    const from = (location.state as { from?: string })?.from;
    if (from) {
      saveRedirectPath(from);
    }
  }, [location.state]);

  return (
    <AuthLayout>
      <ContentContainer>
        <AuthTitle
          title='Welcome Back'
          subtitle='Use one of the following options to sign into your Omili account'
        />

        <AuthOptions />

        <LogInForm />

        <PremierText>Are you new here?</PremierText>

        <CreateAccountButton as={Link} to={AUTH_ROUTES.SIGN_UP}>
          <CreateAccountText>Create An Account</CreateAccountText>
        </CreateAccountButton>
      </ContentContainer>
    </AuthLayout>
  );
};

export default memo(LogIn);
